import script from "./WCPurchaseAgainModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCPurchaseAgainModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCPurchaseAgainModern.vue?vue&type=style&index=0&id=27625e29&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27625e29"]])

export default __exports__